import React from "react";
import {
  Paginator,
  Search as SearchBar,
  FilterView,
  DropdownWrapper,
} from "../../../../shared/widgets";
import { PageWrapper, TableWrapper } from "../../../../shared/layout";

import {
  templateStrings,
  DeviceStatusFilterValues,
  dateFormat,
  MessageType,
} from "../../../../Constant";
import { fetchVehicleMaster } from "../../../../services/vehicleMasterService";
import { fetchBSDData, downLoadBSDData } from "../../../../services/BSDService";
import { connect } from "react-redux";
import { defaultMapDispatchToProps } from "../../../../redux/map-to-props";
import { ChangeTimeButton,RegionSelector } from "../../../../shared/components";
import moment from "moment";
import { EpochtoEpochTZ, timeChange } from "../../../../shared/utils.js";
import classNames from "classnames";
import { Modal, ButtonToolbar } from "react-bootstrap";
import { CreateBSDDevice } from "./create/createBSDDetailView";
import { fetchCurrentServerTime } from "../../../../services/deviceService";
import { setServerTime } from "../../../../redux/actions/settingActions";
import { routes } from "../../../../routing/routes";
import {
  AuthenticationService,
  OPERATIONS,
} from "../../../../services/authorization";
import { DeviceDetailView } from "./detail/BSD/detailView";
import PropTypes from "prop-types";

export class BSDList extends React.Component {
  constructor(props) {
    super(props);
    let authorities = localStorage.getItem("authorities");
    this.authService = AuthenticationService.getInstance();
    let email = localStorage.getItem("userName");
    this.state = {
      authorities: authorities,
      email: email,
      searchString: "",
      pageNo: 0,
      totalItems: 0,
      type: this.props.params.typeId,
      totalPages: 0,
      placeHolder: "Search",
      selectedStatus: DeviceStatusFilterValues.ALL,
      selectedCity: "",
      exportOptions: [
        {
          key: "data",
          value: "Export Data ",
        },
        {
          key: "format",
          value: "Export Format",
        },
      ],
      exportButtonLoader: false,
    };
    this.getList = this.getList.bind(this);
    this.handleSearchChange = this.handleSearchChange.bind(this);
    this.onFilterChange = this.onFilterChange.bind(this);
    this.close = this.close.bind(this);
  }
  componentDidMount() {
    if (this.props.location?.state?.selectedCity) {
      const { selectedCity } = this.props.location.state;
      this.setState({ selectedCity }, () => {
        this.fetchBSDData(this.state.selectedCity);
      });
    } else {
      this.fetchBSDData();
    }

    if (!this.props.serverTimeOffset) {
      fetchCurrentServerTime().then((response) => {
        let time = new Date().getTime();
        let serverTime = parseInt(response.currentTime);
        let offset = serverTime - time;
        this.props.setServerTime(offset);
      });
    }

    this.mounted = true;
    const userRegion = this.authService.getUserFirstRegion();
    this.updateRightsForRegion(userRegion);
    this.fetchMasterData("city", null);
  }


  updateRightsForRegion(region) {
    this.setState({
      canWrite: this.authService.hasRightForOperationOnRouteInRegion(
        routes.BSD,
        region,
        OPERATIONS.WRITE
      ),
    });
  }

  fetchMasterData(masterType, masterParentId) {
    fetchVehicleMaster(masterType, masterParentId, 0, 1000)
      .then((res) => {
        if (this.mounted) {
          this.setState({ cities: res.content });
        }
      })
      .catch((err) => {
        this.errorHandler(err);
      });
  }

  errorHandler(err) {
    if (err.status === 401 || err.message === "Invalid token") {
      this.props.setTokenExpired(true);
    } else if (this.mounted) {
      this.setState({ cities: [] });
      this.props.initiateNotification({
        type: "error",
        message: err.description
          ? err.description
          : "Error while fetching cities",
      });
    }
  }

  render() {
    return (
      <div>
        <PageWrapper.Header
          heading="BSD"
          hideS={true}
          onAdd={this.open.bind(this, null)}
          showButton={this.state.canWrite}
        >
          {this.state.content && (
            <span> Device Count : {this.state.totalItems}</span>
          )}
          <div className="pull-right">
            <a
              onClick={() => {
                this.fetchBSDData(
                  this.state.selectedCity,
                  this.state.selectedStatus.key,
                  this.state.searchString,
                  0
                );
              }}
            >
              <span className="span-icon-refresh refresh-icon" />
            </a>
          </div>
          <div className="pull-right">
            <ChangeTimeButton hideTimeParse={true} />
          </div>
          <DropdownWrapper
            title={
              this.state.exportButtonLoader ? (
                <>
                  <i className="fa fa-spinner fa-spin"></i>
                  <span>{""}</span>
                  <span>Exporting...</span>
                </>
              ) : (
                "Export"
              )
            }
            disabled={this.state.exportButtonLoader}
            menue={this.state.exportOptions}
            onSelect={(value, subValue) => {
              switch (value) {
                case "data": {
                  this.exportData();
                  break;
                }
                case "format": {
                  this.exportData("format");
                  break;
                }
              }
            }}
          ></DropdownWrapper>
          <div className="pull-right search-container">
            <SearchBar
              placeHolder={this.state.placeHolder}
              onSearchChange={this.handleSearchChange}
              value={this.state.searchString}
            />
          </div>
        </PageWrapper.Header>
        <PageWrapper.Body>
          <PageWrapper.BodyHeader>
            <div className="header-button-container">
              <div className="form-group">
                <p className="filters-label">Filter By:</p>
                <div
                  className="dataTables_length wrapper-gps"
                  id="dataTables-example_length"
                >
                  <ButtonToolbar>
                    <RegionSelector
                      filterKey={routes.BSD}
                      onRegionChange={(value)=>this.onFilterChange(value)}
                    />
                   
                    <FilterView
                      selectedValue={this.state.selectedStatus.value}
                      title="Status"
                      menues={DeviceStatusFilterValues}
                      onSelect={(value, subValue) => {
                        this.setState(
                          {
                            selectedStatus: value,
                          },
                          () => {
                            this.fetchBSDData(
                              this.state.selectedCity,
                              this.state.selectedStatus.key,
                              this.state.searchString,
                              0
                            );
                          }
                        );
                      }}
                    />
                  </ButtonToolbar>
                </div>
              </div>
            </div>
          </PageWrapper.BodyHeader>
          <TableWrapper>
            <TableWrapper.Header columns={templateStrings.BSD} />
            {
              <tbody>
                {this.state.content &&
                  this.state.content.map((data) => {
                    return this.displayList(data);
                  })}
                {(!this.state.content ||
                  (this.state.content && this.state.content.length == 0)) && (
                  <tr className="gradeA odd noDataStyle" role="row">
                    <td className="sorting_1" colSpan="6">
                      No Data Found !
                    </td>
                  </tr>
                )}
              </tbody>
            }
          </TableWrapper>
          <Paginator
            pageNo={this.state.pageNo}
            totalPages={this.state.totalPages}
            getList={this.getList}
          />
          {this.displayModal()}
        </PageWrapper.Body>
      </div>
    );
  }

  handleSearchChange(e) {
    this.setState({ searchString: e }, () => {
      this.fetchBSDData(
        this.state.selectedCity,
        this.state.selectedStatus.key,
        this.state.searchString,
        0
      );
    });
  }

  /**
   * Call when Add/Update modal Open.
   */
  open(data) {
    this.setState({
      updateSelection: data,
      showModal: true,
    });
  }

  /**
   * Call when Add/Update modal Close.
   */
  close() {
    this.setState({
      showModal: false,
      updateSelection: null,
      showInfo: false,
      value: [],
    });
  }

  /**
   * API call to get devices.
   * @param pageNo current page number
   */
  getList(pageNo) {
    if (pageNo >= 0 && pageNo <= this.state.totalPages) {
      this.fetchBSDData(
        this.state.selectedCity,
        this.state.selectedStatus.key,
        this.state.searchString,
        pageNo
      );
    }
  }

  onFilterChange(value) {
    this.setState(
      {
        selectedCity: value,
      },
      () => {
        this.fetchBSDData(
          this.state.selectedCity,
          this.state.selectedStatus.key,
          this.state.searchString,
          0
        );
      }
    );
  }

  onDeleteClick() {
    this.setState({
      deleteDeviceId: this.state.deviceId,
      showDeleteModal: true,
    });
  }

  /**
   * Used to show device in row in List view
   * @param item  Object of item to display
   */
  displayList(item) {
    return (
      <tr key={item.deviceId}>
        <td>{item.deviceId}</td>
        <td>
          {item.deviceStop && item.deviceStop["stopId"]
            ? item.deviceStop["stopId"]
            : ""}
        </td>
        <td>
          <span className="protocol">
            {item.deviceStop && item.deviceStop["stopName"]
              ? item.deviceStop["stopName"]
              : "NA"}
          </span>
          <div className="protocol-list">
            {item.deviceStop && item.deviceStop["stopName"]
              ? item.deviceStop["stopName"]
              : "NA"}
          </div>
        </td>
        <td>
          <span >
            <button        
            className={ classNames({
              "red-class": item.deviceStatus == "RED",
              "green-class": item.deviceStatus == "GREEN",
              "yellow-class": item.deviceStatus == "YELLOW",
              "transparent-btn": true,
            })}>
              <i className="fa fa-circle" aria-hidden="true"></i>
            </button>
          </span>
        </td>
        {/* <td>{item.protocol ? item.protocol : ""}</td> */}
        <td>{item.city ? item.city.toUpperCase() : ""}</td>

        <td>{item.networkStrength ? item.networkStrength : ""}</td>
        <td>
          <span className="protocol">
            {item.lastPacketArrivedAt
              ? timeChange(
                  parseInt(item.lastPacketArrivedAt),
                  this.props.serverTimeOffset
                )
              : "NA"}
          </span>
          <div className="protocol-list">
            {item.lastPacketArrivedAt
              ? moment(
                  new Date(
                    EpochtoEpochTZ(
                      parseInt(item.lastPacketArrivedAt),
                      localStorage.getItem("timeZone")
                    )
                  )
                ).format(dateFormat)
              : "NA"}
          </div>
        </td>
        <td>{item.deviceHealth ? item.deviceHealth : ""}</td>
        <td>{item.displayColumnCount ? item.displayColumnCount : ""}</td>

        <td className="action-column">
          {this.state.canWrite && (
            <span className="table-icons edit-icon">
              <a onClick={this.open.bind(this, item)}>
                <span className="edit-view-icon" />
                <span className="protocol-list">edit</span>
              </a>
            </span>
          )}
          <span className="table-icons view-icon">
            <a
              onClick={() =>
                this.setState({
                  showInfo: true,
                  updateSelection: item,
                })
              }
            >
              <i className="fa fa-eye protocol" aria-hidden="true" />
              <span className="protocol-list">view details</span>
            </a>
          </span>
          <span className="table-icons view-icon">
            <a onClick={() => this.navigateToDetail(item.deviceId)}>
              <i className="fa fa-history protocol" aria-hidden="true" />
              <span className="protocol-list">view logs</span>
            </a>
          </span>
        </td>
      </tr>
    );
  }

  fetchBSDData(city, status, searchKey, pageNo) {
    this.props.updateLoader(true);
    fetchBSDData(city, this.props.timeInterval, status, searchKey, pageNo)
      .then((res) => {
        this.props.updateLoader(false);

        if (this.mounted && res.items)
          this.setState({
            content: res.items,
            totalPages: res.totalPages,
            pageNo: res.currentPage,
            totalItems: res.totalItems,
          });
        this.props.updateLoader(false);
      })
      .catch((err) => {
        this.props.updateLoader(false);

        if (err.status === 401 || err.message === "Invalid token") {
          this.props.setTokenExpired(true);
        } else if (this.mounted) {
          this.props.updateLoader(false);
          this.setState({ content: [], totalPages: 0, pageNo: 0 });
          this.props.initiateNotification({
            type: "error",
            message: err.description
              ? err.description
              : "Error while fetching devices",
          });
        }
      });
  }
  exportData(exportKey) {
    let timeoutId;
    const hideLoader = () => {
      timeoutId = setTimeout(() => {
        this.setState({ exportButtonLoader: false });
      }, 60000);
    };

    hideLoader();
    downLoadBSDData(
      this.state.selectedCity,
      this.props.timeInterval,
      this.state.selectedStatus.key,
      exportKey
    )
      .then(this.setState({ exportButtonLoader: true }))

      .then((res) => {
        clearTimeout(hideLoader);
        console.log(res);
        this.setState({ exportButtonLoader: false });
      })
      .catch((err) => {
        clearTimeout(hideLoader);
        this.setState({ exportButtonLoader: false });
        console.log(err);
        if (err.status === 401 || err.message === "Invalid token") {
          console.log("unauthorized", err.description);
          this.props.setTokenExpired(true);
        }
      });
  }

  navigateToDetail(deviceId) {
    this.props.navigate(`/BSD/${deviceId}`, {
      state: { selectedCity: this.state.selectedCity },
    });
  }

  /**
   * Used to show Modal for "Add new device" or "Update device"
   */
  displayModal() {
    return (
      <Modal
        dialogClassName="custom-vehicle-modal"
        show={this.state.showModal || this.state.showInfo}
        onHide={this.close.bind(this)}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {this.state.showModal
              ? this.state.updateSelection
                ? "Update Device"
                : "Add new Device"
              : this.state.showInfo
              ? "Device Details"
              : ""}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {this.state.showModal && (
            <CreateBSDDevice
              updateSelection={this.state.updateSelection}
              email={this.state.email}
              showInfo={this.state.showInfo}
              onComplete={(e, msg) => {
                if (e == MessageType.SUCCESS) {
                  this.setState({ searchString: "" }, () => {
                    this.fetchBSDData(
                      this.state.selectedCity,
                      this.state.selectedStatus.key,
                      this.state.searchString,
                      0
                    );
                  });
                  this.props.initiateNotification({
                    type: e,
                    message: msg,
                  });
                } else if (e === MessageType.ERROR && msg === "Invalid token") {
                  this.props.setTokenExpired(true);
                } else {
                  this.props.initiateNotification({
                    type: e,
                    message: msg,
                  });
                }
                this.close();
              }}
              onClose={this.close.bind(this)}
            />
          )}
          {this.state.showInfo && (
            <DeviceDetailView data={this.state.updateSelection} />
          )}
        </Modal.Body>
      </Modal>
    );
  }
}
function mapStateToProps(state) {
  return {
    timeInterval: state.Settings.timeInterval,
    serverTimeOffset: state.Settings.serverTimeOffset,
  };
}
const mapDispatchToProps = (dispatch, state) => ({
  ...defaultMapDispatchToProps(dispatch, state),
  setServerTime: (value) => {
    dispatch(setServerTime(value));
  },
});
export default connect(mapStateToProps, mapDispatchToProps)(BSDList);

BSDList.propTypes = {
  params: PropTypes.object,
  location: PropTypes.object,
  navigate: PropTypes.func,
  serverTimeOffset: PropTypes.number,
  timeInterval: PropTypes.any,
  setServerTime: PropTypes.func,
  updateLoader: PropTypes.func,
  setTokenExpired: PropTypes.func,
  initiateNotification: PropTypes.func,
};